import customer from './modules/customer'
import order from './modules/order'
import approval from './modules/approval'
import collection from './modules/collection'
import risk from './modules/risk'
import payout from './modules/payout'
import custTrans from './modules/custTrans'
import remind from './modules/remind'
import repayReport from './modules/repayReport'
import repayOverDueReport from './modules/repayOverDueReport'
import platformCollection from './modules/platformCollection'
import custServiceWorkOrder from './modules/custServiceWorkOrder'
import collectorTotalFollow from './modules/collectorTotalFollow'
import teleMarket from "./modules/teleMarket"
import custConvertReal from './modules/custConvertReal'
import reborrowCount from './modules/reborrowCount'
import coupon from './modules/coupon'
import repaycert from './modules/repaycert'

export default {
  code: 'en-US',
  label: 'English',
  "Remove his order": "Remove his order",
  "Unfinished": "Unfinished",
  "Dispatch order to": "Dispatch order to",
  "Collector account": "Collector's account",
  "User Type": "User Type ",
  "Deferral rate": "Deferral rate",
  "Installment as aggregation condition": "Installment as aggregation condition",
  error: 'error',
  tips: 'tips',
  reset: 'reset',
  search: 'search',
  save: 'Save',

  searchColAll: 'Consulta',
  searchColCur: 'El día de la consulta',
  searchColHis: 'Historial de consulta',

  check: 'check',
  edit: 'edit',
  more: 'more',
  delete: 'delete',
  enter: 'Please enter',
  select: 'Please select',
  show: 'show',
  hide: 'hide',
  confirm: 'confirm',
  cancel: 'cancel',
  sort: 'sort',
  action: 'Operaciones',
  operation: 'Operation',
  add: 'Add',
  view: 'View',
  success: 'Success',
  fail: 'Fail',
  userName: 'Username',
  signOut: 'Sign out',
  signIn: 'Sign in',
  requestFail: 'Request failed, please try again',
  confirmDelete: 'Confirm to delete?',
  oldPassword: 'Old Password',
  password: 'Password',
  code2: "Verification code",
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',
  createRepayOrder: 'Create PayOrder',
  createRepayUrl: 'Create PayUrl',
  repayStatusSync: 'repay status sync',
  payoutStatusSync: 'payout status sync',
  sex: 'Género',
  name: 'Name',
  birthday: 'Birthday',
  date: 'Date',
  time: 'Time',
  man: 'Male',
  woman: 'Female',
  email: 'Buzón de correo',
  phone: 'Phone',
  phoneNo: 'Phone Number',
  enable: 'Enable',
  disable: 'Disable',
  status: 'Status',
  remark: 'Remark',
  decLateFee: 'Discount',
  decCapitalFee: 'Waiver of extension fee',
  decCapitalAndLateFee: 'Waiver of extension fees and late fees',
  clearDeductionFee: 'Clear the deduction amount',
  handle: 'Handle',
  extendRepay: 'Rollover repayment',
  exportFile: 'export',
  display: 'Number of items displayed per page',
  reCreate: 'ReCreate',
  flush: 'Flush',
  createReport: 'Create Report',
  close: 'Close',
  feeName: 'Fee Name',
  chargeNode: 'Charge Node',
  chargeStandard: 'Charge Standard',
  effectiveTime: 'Effective Time',
  pleaseInput: 'Please input',
  selectTime: 'Select time',
  loanRatio: 'Loan Ratio',
  fixedAmount: 'Fixed Amount',
  loanDeduct: 'Deduct at loan',
  applyDeduct: 'Deduct at apply',
  dueDeduct: 'Deduct at due',
  repayDeduct: 'Deduct at repay',
  platformServiceFee: 'Platform Service Fee',
  applicableObject: 'Applicable Object',
  individualAndEnterprise: 'Individual + Enterprise',
  withdrawalFee: 'Withdrawal Fee',
  collectedAtWithdrawal: 'Collected at Withdrawal',
  investmentAmountRatio: 'Investment Amount Ratio',
  productName: 'Product Name',
  productType: 'Product Type',
  receiptMode: 'Receipt Mode',
  preCollected: 'Pre-collected',
  postCollected: 'Post-collected',
  formalProduct: 'Formal Product',
  submissionProduct: 'Submission Product',
  productDetails: 'Product Details',
  productConfigDetails: 'Product Config Details',
  editDetails: 'Edit Details',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  valid: 'Valid',
  invalid: 'Invalid',
  modify: 'Modify',
  inputProductName: 'Please enter product name',
  selectReceiptMode: 'Please select receipt mode',
  selectStatus: 'Please select status',
  selectProductType: 'Please select product type',
  feeRateName: 'Fee Rate Name',
  fixedAmount: 'Fixed Amount',
  fixedRate: 'Fixed Rate',
  allow: 'Allow',
  notAllow: 'Not Allow',
  periodDuration: 'Period Duration',
  eachPeriodDuration: 'Each Period Duration',
  maxAmount: 'Max Amount',
  minAmount: 'Min Amount',
  incrAmount: 'Incr Amount',
  incrQuota: 'Incr Quota',
  allowDiferTime: 'Allow Difer Time',
  allowPrepay: 'Allow Prepay',
  serviceFeeRate: 'Service Fee Rate',
  diferFeeRate: 'Difer Fee Rate',
  overdueRate: 'Overdue Rate',
  dayInterestRate: 'Day Interest Rate',
  ivaFee: 'IVA Fee',
  addConfig: 'Add Config',
  editConfig: 'Edit Config',
  sort: 'Sort',
  type: 'Type',
  configName: 'Config Name',
  configContent: 'Config Content',
  inputSort: 'Please input sort!',
  inputType: 'Please input type!',
  inputConfigName: 'Please input config name!',
  inputConfigContent: 'Please input config content!',
  sortPlaceholder: 'Smaller value, higher priority',
  applyAmountWeight: 'Apply Amount Weight (e.g. 1,1,1)',
  serviceFeeWeight: 'Service Fee Weight (e.g. 1,1,1)',
  inputPeriodDuration: 'Please input period duration!',
  inputEachPeriodDuration: 'Please input each period duration!',
  inputApplyAmountWeight: 'Please input apply amount weight!',
  inputServiceFeeWeight: 'Please input service fee weight!',
  inputMaxAmount: 'Please input max amount!',
  inputMinAmount: 'Please input min amount!',
  inputIncrAmount: 'Please input incr amount!',
  inputIncrQuota: 'Please input incr quota!',
  inputAllowDiferTime: 'Please input allow difer time!',
  inputAllowPrepay: 'Please input allow prepay!',
  inputServiceFeeRate: 'Please input service fee rate!',
  inputDiferFeeRate: 'Please input difer fee rate!',
  inputOverdueRate: 'Please input overdue rate!',
  inputDayInterestRate: 'Please input day interest rate!',
  inputIvaFee: 'Please input iva fee!',
  waitingForFullBid: 'Waiting for Full Bid',
  fullBid: 'Full Bid',
  failedBid: 'Failed Bid',
  completed: 'Completed',
  disbursementSuccess: 'Loan Success',
  unknown: 'Unknown',
  thirdPartyTransactionNo: 'Third Party Transaction No',
  businessTransactionNo: 'Business Transaction No',
  orderNo: 'Order No',
  paymentLink: 'Payment Link',
  email: 'Email',
  names: 'Names',
  date: 'Date',
  channel: 'Channel',
  isReductionAmt: 'Confirm Reduction?',
  lateFee: 'Late Fee: ',
  reductionAmount: 'Reduction Amount: ',
  inputReductionAmount: 'Reduction amount cannot be empty',
  reductionAmountError: 'Reduction amount cannot be greater than late fee',
  isSettle: 'Confirm Offline Repayment?',
  verifyPassword: 'Verify Password: ',
  inputPassword: 'Password cannot be empty',
  confirmExtendOffline: 'Confirm Offline Extension Repayment?',
  platformOrderNo: 'Platform Order No',
  repaymentCode: 'Repayment Code',
  mobileNo: 'Mobile No',
  orderId: 'Order ID',
  transactionType: 'Transaction Type',
  transactionAmount: 'Transaction Amount',
  couponAmount: 'Coupon Amount',
  createTime: 'Create Time',
  updateTime: 'Update Time',
  all: 'All',
  newCustomer: 'New Customer',
  oldCustomer: 'Old Customer',
  normalOrder: 'Normal Order',
  extensionOrder: 'Extension Order',
  orderType: 'Order Type',
  minApplyAmount: 'Min Apply Amount',
  maxApplyAmount: 'Max Apply Amount',
  loanCountNum: 'Loan Count',
  periodCount: 'Period',
  totalPeriod: 'Total Period',
  applyDuration: 'Apply Duration',
  feeRate: 'Fee Rate',
  mainPackageProduct: 'Main Package Product',
  multiLoanProduct: 'Multi Loan Product',
  firstLoan: 'First Loan',
  repeatLoan: 'Repeat Loan',
  components: {
    total: 'Total',
    items: 'items',
  },

  home: {
    title: 'Home',
    modifyPassword: 'Modify Password',
    userInfoFail: 'Requesting user information failed, please try again',
    signOutInfo: 'Do you really want to log out?',
    userNameTips: 'Please enter user name',
    passwordTips: 'Please enter the password',
    code: "Please enter the verification code",
    earlyMorning: 'Good morning',
    morning: 'Good morning',
    noon: 'Good noon',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    welcome: 'welcome',
    welcomeBack: 'welcome back',
    inputGoogleCode: 'Please enter the Google Verification Code',
    bindGoogleCode: 'Please Bind Google Verification Code',
    okText: "I have bound"
  },
  user: {
    settings: 'Settings',
    changePassword: 'Change Password',
    logout: 'Logout',
    confirmLogout: 'Confirm Logout',
    logoutConfirmContent: 'Are you sure to logout?',
    passwordModified: 'Password changed successfully',
    passwordModifyFailed: 'Failed to change password',
    passwordNotMatch: 'The two passwords do not match',
    oldPasswordRequired: 'Please enter old password',
    newPasswordRequired: 'Please enter new password',
    confirmPasswordRequired: 'Please enter new password again',
    passwordMinLength: 'Password length must be at least 6 characters'
  },
  language: {
    switchLanguage: 'Switch Language',
    switchSuccess: 'Language switched successfully'
  },
  common: {
    ok: 'OK',
    cancel: 'Cancel'
  },
  customer: customer.en,
  system: {
    title: 'System Management',
    menuList: {
      menu: 'menu',
      title: 'Menu Management',
      index: 'index',
      menuName: 'name',
      icon: 'menu icon',
      type: 'type',
      superiorMenu: 'Superior Menu',
      menuUrl: 'Menu URL',
      menuComponent: 'Menu Component',
      sort: 'sort',
      action: 'action',
      edit: 'edit',
      delete: 'delete',
      add: 'add',
      mainSub: 'main menu',
      submenu: 'sub menu',
      buttonPermission: 'button/permission',
      nameCn: 'English Name',
      nameEn: 'English Name',
      nameEs: 'Việt Name',
      nameAr: 'Ar Name',
      nameFr: 'Fr Name',
      preMenu: 'previous menu',
      menuCode: 'menu code',
    },
    userList: {
      title: 'User List',
      index: 'index',
      name: 'name',
      phone: 'phone',
      mail: 'mail',
      time: 'Create Time',
      position: 'Department / post',
      role: 'role',
      app: 'application',
      status: 'status',
      action: 'action',
      add: 'add',
      edit: 'edit',
      password: 'password',
      delete: 'delete',
      callUserName: 'callUserName',
      callUserPassword: 'callUserPassword',
      resetGoogleAuth: 'reset G-auth',
      viewGoogleAuth: 'view G-auth',
      addUser: 'Add User',
      editUser: 'Edit User',
      resetAuthenticator: 'Reset Authenticator',
      confirmResetAuthenticator: 'Confirm to reset authenticator?',
      deleteUser: 'Delete User',
      confirmDeleteUser: 'Confirm to delete current user?'
    },
    roleList: {
      title: 'Role List',
      index: 'index',
      type: 'role type',
      name: 'Role Name',
      code: 'role code',
      description: 'description',
      time: 'create time',
      action: 'action',
      add: 'add',
      edit: 'edit',
      password: 'password',
      delete: 'delete',
      permission: 'permission',
    },
    parameterConfiguration: {
      title: 'Customer Service Center Configuration',
      loanApp: 'Loan APP',
      investApp: 'Invest APP',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      contactPhone: 'Customer Service Phone:',
      whatsappAccount: 'Customer Service Zalo Account:',
      email: 'Customer Service Email:',
      inputPlaceholder: 'Please enter',
      fillAtLeastOne: 'Please fill in at least one field',
      canceled: 'Cancelled',
      saved: 'Saved successfully',
      fieldName: 'Field Name',
      enabled: 'Enabled',
      maxLength: 'Max Length',
      description: 'Description',
    },
  },
  investorList: {
    s1: 'Hello~ A busy day begins, let\'s work hard together!',
    s2: 'New Data Conversion Summary',
    s3: 'New User Conversion Funnel',
    s4: 'Borrower Registration Monitoring',
    s5: 'Borrower Login Monitoring',
    s6: 'Returning User Re-borrow Application Conversion Data',
    s7: 'Returning User Re-borrow Disbursement Conversion Data',
    s8: 'Create Menu/Button',
    s9: 'Please select a menu to view details',
    s10: 'Type',
    s11: 'Name',
    s12: 'Path',
    s13: 'Component',
    s14: 'Icon',
    s15: 'Sort Order',
    s16: 'Status',
    s17: 'Show',
    s18: 'Hide',
    s19: 'System Role',
    s20: 'Application Role',
    s21: 'Authorize',
    s22: 'Please select a date',
    Downloadinvoice: 'Download invoice',
    Downloadcontract: 'Download contract',
    DownloadInvestmentContract: 'Download investment contract',
    downloading: 'Downloading, please wait...',
    tzrID: 'Investor ID',
    mc: 'Name',
    sjh: 'Phone Number',
    smrz: 'Real-name Authentication Completed',
    fxpg: 'Risk Assessment Completed',
    sfzh: 'ID Number',
    fxdj: 'Risk Level',
    tzddbh: 'Investment Order No.',
    tzzcbid: 'Investment Asset Package ID',
    tzrzh: 'Investor Account',
    zt: 'Status',
    yx: 'Email',
    zcsj: 'Registration Time',
    cz: 'Action',
    xq: 'Details',
    jy: 'Disable',
    qy1: 'Enable',
    ysz: 'Verified',
    wsz: 'Unverified',
    ysg: 'Assessed',
    wsg: 'Not Assessed',
    zc: 'Normal',
    tzrmc: 'Investor Name',
    tzrlx: 'Investor Type',
    tzzcbid: 'Investment Asset Package ID',
    tzje: 'Investment Amount',
    tzrzt: 'Investment Status',
    tzhbl: 'Investment Return Rate',
    tzzq: 'Investment Period',
    yqsy: 'Expected Return',
    ptffw: 'Platform Service Fee',
    tzsj: 'Investment Time',
    gr: 'Individual',
    qy: 'Enterprise',
    jg: 'Institution',
    jr: 'Today',
    czbs: 'Recharge Count',
    czje: 'Recharge Amount',
    rgbs: 'Subscription Count',
    rgje: 'Subscription Amount',
    fkbs: 'Disbursement Count',
    fkje: 'Disbursement Amount',
    tzdqbd: 'Matured Investment Subject',
    dqjdje: 'Matured Unfreeze Amount',
    txje: 'Withdrawal Amount',
    czlsh: 'Recharge Serial No.',
    czsj: 'Recharge Time',
    cg: 'Success',
    sb: 'Failed',
    qb: 'All',
    czzt: 'Recharge Status',
    djyy: 'Freeze Reason',
    djsj: 'Freeze Time',
    tzbd: 'Investment Subject',
    tzdj: 'Investment Freeze',
    fqrg: 'Initiate Subscription',
    rgcg: 'Subscription Successful',
    rgsb: 'Subscription Failed',
    fqtk: 'Initiate Refund',
    tkcg: 'Refund Successful',
    mb: 'Fully Subscribed',
    zjchz: 'Funds Repaying',
    yjs: 'Ended',
    xgtzzt: 'Modify investment status',
    zcbid: 'Asset Package ID',
    zcbmc: 'Asset Package Name',
    zcbzt: 'Asset Package Status',
    zcbdj: 'Asset Package Grade',
    bdje: 'Subject Amount (₫)',
    syl: 'Yield (Annualized)',
    zcbgc: 'Composition of asset package (borrower)',
    zcbgc1: 'Composition of asset package (investor)',
    tzzqt: 'Investment Period (Days)',
    jkrmx: 'Borrower Details',
    tzrmx: 'Investor Details',
    tzrmc: 'Investor Name',
    tzrxm: 'Investor Full Name',
    pprq: 'Matching Date',
    zje: 'Total Amount',
    jkrs: 'Number of Borrowers',
    tzrs: 'Number of Investors',
    jkrmc: 'Borrower Name',
    jkrid: 'Borrower ID',
    jkje: 'Loan Amount',
    jkqx: 'Loan Term',
    jkzt: 'Loan Status',
    nhll: 'Annual Interest Rate',
    tzzb: 'Investment Proportion',
    tzrsjh: 'Investor Phone Number',
    lb: 'Failed Bid',
    ddk: 'Pending Disbursement',
    tzz: 'Investing',
    jkz: 'Borrowing',
    hkz: 'Repaying',
    ywc: 'Completed',
    hkddh: 'Repayment Order No',
    hkrxm: 'Repayer Name',
    hkrsjh: 'Repayer Phone Number',
    hkrzh: 'Repayer Account',
    zjfpmx: 'Fund Allocation Details',
    hkje: 'Repayment Amount',
    fpje: 'Allocated Amount',
    ysze: 'Total Receivable',
    ssze: 'Total Received',
    jkrys: 'Borrower Receivable',
    jkrss: 'Borrower Received',
    tzrys: 'Investor Receivable',
    tzrss: 'Investor Received',
    sfsj: 'Charge Time',
    zh: 'Account',
    fymc: 'Fee Name',
    sfjd: 'Charge Node',
    fkskc: 'Deducted at Disbursement',
    hkssq: 'Charged at Repayment',
    sfbz: 'Charging Standard',
    ysje: 'Amount Receivable',
    ssje: 'Amount Received',
    sxrq: 'Effective Date',
    qsrzh: 'Please enter account',
    czzh: 'Recharge Account',
    czrq: 'Recharge Date',
    czr: 'Recharger',
    cjcz: 'Create Recharge',
    qsrczje: 'Please enter recharge amount',
    qsryhsjh: 'Please enter user phone number',
    qsrbz: 'Please enter remarks',
    jkrsjh: 'Borrower Phone Number',
    djje: 'Freeze Amount',
  },
  order: order.en,
  account: {
    accountDetail: 'Account Detail',
  },
  postLoan: {
    title: 'Post-loan Management',
  },
  approval: approval.en,
  collection: collection.en,
  remind: remind.en,
  risk: risk.en,
  repayReport: repayReport.en,
  payout: payout.en,
  repayOverDueReport: repayOverDueReport.en,
  collectorTotalFollow: collectorTotalFollow.en,
  other: {
    title: 'other',
  },
  platformCollection: platformCollection.en,
  custServiceWorkOrder: custServiceWorkOrder.en,
  teleMarket: teleMarket.en,
  custConvertReal: custConvertReal.en,
  reborrowCount: reborrowCount.en,
  coupon: coupon.en,
  repaycert: repaycert.en,
  custTrans: custTrans.en,
  borrowerCenter: {
    basicInfo: 'Basic Information',
    userId: 'User ID',
    name: 'Name',
    gender: 'Gender',
    idNo: 'ID Number',
    birthDate: 'Date of Birth',
    monthlyIncome: 'Monthly Income',
    jobTitle: 'Job Title',
    mobile: 'Mobile Phone',
    city: 'City',
    platformEvaluation: 'Platform Evaluation',
    financialCapability: 'Financial Capability',
    creditLevel: 'Credit Level',
    creditScore: 'Credit Score',
    conclusion: 'Conclusion',
    male: 'Male',
    female: 'Female',
    pleaseInputEmail: 'Please input email!',
    // CustomerModifyModal translations
    customerInfo: 'Customer Information',
    loginAccount: 'Login Account',
    idNumber: 'ID Number',
    birthDateTime: 'Date of Birth',
    registrationTime: 'Registration Time',
    basicInfoSection: 'Basic Information',
    emailAddress: 'Email',
    residenceCity: 'City of Residence',
    detailedAddress: 'Detailed Address',
    maritalStatus: 'Marital Status',
    workInfo: 'Work Information',
    occupation: 'Occupation',
    employmentDate: 'Employment Date',
    companyName: 'Company Name',
    workLocation: 'Work Location',
    companyPhone: 'Company Phone',
    contactInfo: 'Contact Information',
    firstContact: 'First Contact',
    relationship: 'Relationship',
    contactPhone: 'Contact Phone',
    secondContact: 'Second Contact',
    documentInfo: 'Document Information',
    frontSide: 'Front Side',
    backSide: 'Back Side',
    facePhoto: 'Face Photo',
    paymentAccountInfo: 'Payment Account Information',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    accountHolderName: 'Account Holder Name',
    accountHolderIdNumber: 'Account Holder ID Number',
    platformEvaluationSection: 'Platform Evaluation',
    married: 'Married',
    unmarried: 'Unmarried',
  },
}
